module.exports = __webpack_public_path__ + "img/zhengdong.698bfc0b.png";